'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { logError } from '@util/logError';
import AttributionProvider from 'context/AttributionContext';
import AuthProvider from 'context/AuthContext';
import { BikeFilterProvider } from 'context/BikeFilterContext';
import { ChatProvider } from 'context/ChatContext';
import { ConfirmationModalProvider } from 'context/ConfirmationModalContext';
import { ConversationsProvider } from 'context/ConversationsContext';
import { NotificationProvider } from 'context/NotificationContext';
import ProgressBarProvider from 'context/ProgressBarProvider';
import { SearchProvider } from 'context/SearchContext';
import { ShoppingCartProvider } from 'context/ShoppingCartContext';
import { StripeProvider } from 'context/StripeContext';
import { ToastProvider } from 'context/ToastContext';
import { WelcomeBackModal } from 'features/welcomeBack';
import type { ReactNode } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      throwOnError: (err, query) => {
        logError(err, query.queryKey.join('/'));
        return process.env.NODE_ENV === 'development';
      },
    },
  },
});
// PUT ALL OF YOUR CONTEXT PROVIDERS HERE
function ProviderProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AttributionProvider>
        <ProgressBarProvider>
          <SearchProvider>
            <AuthProvider>
              <BikeFilterProvider>
                <StripeProvider>
                  <ToastProvider>
                    <ShoppingCartProvider>
                      <NotificationProvider>
                        <ConversationsProvider>
                          <ChatProvider>
                            <ConfirmationModalProvider>
                              {children}
                            </ConfirmationModalProvider>
                            <WelcomeBackModal />
                          </ChatProvider>
                        </ConversationsProvider>
                      </NotificationProvider>
                    </ShoppingCartProvider>
                  </ToastProvider>
                </StripeProvider>
              </BikeFilterProvider>
            </AuthProvider>
          </SearchProvider>
        </ProgressBarProvider>
      </AttributionProvider>
    </QueryClientProvider>
  );
}

export default ProviderProvider;
